/**
 * active/deactivate dom scroll
 * @param {boolean} activate
 */
export const toggleDOMScroll = activate => {
  if (activate) {
    document.body.removeAttribute('style')
    document.querySelector('html').removeAttribute('style')
  } else {
    document.body.style.overflowY = 'hidden'
    document.querySelector('html').style.overflowY = 'hidden'
  }
}

/**
 * Show/hide modal
 * @param {boolean} activate
 * @param {node} modal
 */
export const toggleModal = (activate, modal = false) => {
  if (activate) {
    modal.classList.add('is-active')
  } else {
    if (modal === false) {
      modal = document.querySelector('.modal.is-active')
    }
    modal.classList.remove('is-active')
  }
}

/**
 * Show/hide nodes
 * @param {node} nodeToShow
 * @param {node} nodeToHide
 */
export const toggleNode = (nodeToShow, nodeToHide = null) => {
  if (!nodeToShow.classList.contains('is-active')) {
    nodeToHide.classList.add('is-hidden')
    nodeToHide.classList.remove('is-active')
    nodeToShow.classList.remove('is-hidden')
    nodeToShow.classList.add('is-active')
  } else {
    nodeToShow.classList.remove('is-active')
    nodeToShow.classList.add('is-hidden')
  }
}

/**
 * Mutation Observer Helper function
 * //developer.mozilla.org/en-US/docs/Web/API/MutationObserver/observe
 * @param {string} sel The DOM selector to watch
 * @param {object} opt MutationObserver options
 * @param {function} cb Pass Mutation object to a callback function
 */
export const Observe = (sel, opt, cb) => {
  const Obs = new MutationObserver((m) => [...m].forEach(cb))
  document.querySelectorAll(sel).forEach(el => Obs.observe(el, opt))
}

/**
 * Convert a photo exif position ({ lat: '47.2 N', lng: '1.5 W' }) to a google maps position
 * @param {object} position
 * @returns {object|null}
 */
export const getPhotoMapPosition = position => {
  if (!position || !position.lat || !position.lng) return null

  const toCoordinate = value => {
    const [coordinate, ref] = String(value).trim().split(/\s+/)
    const parsed = parseFloat(coordinate)

    return ['S', 'W'].includes(ref?.toUpperCase()) ? -Math.abs(parsed) : parsed
  }
  const lat = toCoordinate(position.lat)
  const lng = toCoordinate(position.lng)

  return isNaN(lat) || isNaN(lng) ? null : { lat, lng }
}
